const sendReplyDescriptor = Object.freeze({
    type: 'send-reply',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):step-final',
    fallbackTitle: 'Send reply',
    defaultDescriptionKey: null,
    fallbackDescription: 'Review the response and send it to the customer.',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: ['request.reply-documents', 'request.other-information'],
        writes: ['request.reply'],
    },
    effects: {
        publishes: [],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {},
    },
    settingsUi: {},
})

export { sendReplyDescriptor }
export default sendReplyDescriptor
